module.exports = __webpack_public_path__ + "img/symbol_2.f28bd2a5.png";